<template>
  <Main>
    <template v-slot:toolbar>
      <div class="white">
        <StepToolbar
          class="max-content-width"
          :steps="toolbarSteps"
          :current-step="currentStep"
        />
      </div>
    </template>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        :items="breadcrumbAccordingStep"
        @return="previousStep"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb :items="breadcrumbAccordingStep" @return="previousStep" />
    </template>
    <fragment v-if="showForms">
      <InsuranceStepForm
        v-if="currentStep.name == steps.form && currentInsuranceCompany"
        @updateStep="changeStep"
        :form="formAccordingStep"
        @relationshipContact="stepRelationshipContact"
        :is-edit="true"
      />
      <InsuranceStepModality
        v-if="currentStep.name == steps.modality"
        @updateStep="changeStep"
        :form="formAccordingStep"
        :return="returnStep"
        :insurance="getForm(steps.form)"
        @submit="submit"
        @editModality="editModality"
      />
      <ListModality
        v-if="currentStep.name == steps.selectModality"
        @updateStep="changeStep"
        :return="returnStep"
        :insurance="getForm(steps.form)"
        :form="getModality()"
        :modality="getForm(steps.modality)"
        @newModality="newModality"
      />
      <NewRelationshipContact
        v-if="currentStep.name == steps.newContact"
        @updateStep="changeStep"
        @updateContact="saveRelationshipContact"
        :return="returnStep"
        :form="formAccordingStep"
        :insurance="getForm(steps.form)"
        @setReturnFalse="setReturnFalse"
      />
      <EditModalityChosen
        v-if="currentStep.name == steps.editModality"
        @updateStep="changeStep"
        :return="returnStep"
        :modality="getForm(steps.selectModality)"
        :insurance="getForm(steps.form)"
        :form="formAccordingStep"
        @updateModality="saveModality"
        @edit="editSubModality"
        @new="newSubModality"
        @setReturnFalse="setReturnFalse"
      />
      <ListSubModality
        v-if="currentStep.name == steps.selectSubModality"
        @updateStep="changeStep"
        :return="returnStep"
        :modality="getForm(steps.selectModality)"
        :insurance="getForm(steps.form)"
        :form="formAccordingStep"
        :sub-modality="getForm(steps.editModality)"
      />
      <EditSubModalityChosen
        v-if="currentStep.name == steps.editSubModality"
        @updateStep="changeStep"
        :return="returnStep"
        :insurance="getForm(steps.form)"
        :sub-modality="getForm(steps.selectSubModality)"
        :form="formAccordingStep"
        @updateSubModality="saveSubModality"
        @setReturnFalse="setReturnFalse"
      />
    </fragment>
    <ModalCancelInsurance
      @close="closeModal"
      v-model="modalCancel"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </Main>
</template>
<script>
import InsuranceStepForm from "../new_insurance_steps/InsuranceStepForm";
import InsuranceStepModality from "../new_insurance_steps/InsuranceStepModality";
import ListModality from "../new_insurance_steps/ListModality";
import NewRelationshipContact from "../new_insurance_steps/NewRelationshipContact";
import ModalCancelInsurance from "../components/ModalCancelInsurance";
import EditModalityChosen from "../new_insurance_steps/EditModalityChosen";
import ListSubModality from "../new_insurance_steps/ListSubModality";
import EditSubModalityChosen from "../new_insurance_steps/EditSubModalityChosen";
import { mapActions, mapState } from "vuex";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { normalizeCnpj } from "@/utils/documents.js";
import _ from "lodash";
const toolbarSteps = [
  {
    name: "1. Seguradora",
    step: 1
  },
  {
    name: "2. Adicionar Modalidade",
    step: 2
  }
];
const tabSteps = {
  form: "insurance_company step form",
  modality: "insurance_company step modality",
  selectModality: "insurance_company select modality",
  newContact: "insurance_company new contact",
  editModality: "insurance_company edit modality",
  selectSubModality: "insurance_company select sub modality",
  editSubModality: "insurance_company edit sub modality"
};
const itemSteps = [
  {
    form: {
      ativo: true,
      nome: null,
      cnpj: null,
      logo: null,
      razao_social: null,
      nome_fantasia: null,
      registro_susep: null,
      categoria: null,
      endereco: {
        cep: null,
        logradouro: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        uf: null
      },
      contatos_linha_credito: [],
      contatos_relacionamento: []
    },
    step: tabSteps.form,
    breadcrumb: [
      {
        to: "insurance_company",
        text: "Editar Seguradora"
      }
    ]
  },
  {
    form: {
      aceita_link_arquivos: false,
      tamanho_maximo_arquivos_mb: null,
      modalidades: []
    },
    step: tabSteps.modality,
    breadcrumb: [
      {
        to: "insurance_company step form",
        text: "Editar Seguradora"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.selectModality,
    breadcrumb: [
      {
        to: "insurance_company step modality",
        text: "Editar Seguradora"
      }
    ]
  },
  {
    form: {
      ativo: true,
      nome: null,
      email: null,
      telefone1: null,
      telefone2: null,
      departamento: null
    },
    step: tabSteps.newContact,
    breadcrumbAdd: [
      {
        to: "insurance_company step form",
        text: "Adicionar Contatos Relacionamento"
      }
    ],
    breadcrumbEdit: [
      {
        to: "insurance_company step form",
        text: "Editar Contatos Relacionamento"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.editModality,
    breadcrumb: [
      {
        to: "insurance_company step modality",
        text: "Editar Seguradora"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.selectSubModality,
    breadcrumb: [
      {
        to: "insurance_company edit modality",
        text: "Editar Seguradora"
      }
    ]
  },
  {
    form: {},
    step: tabSteps.editSubModality,
    breadcrumb: [
      {
        to: "insurance_company select sub modality",
        text: "Editar Seguradora"
      }
    ]
  }
];
const firstStep = {
  name: "insurance_company step form",
  step: 1
};
export default {
  beforeRouteLeave(to, from, next) {
    if (this.cancel || this.formIsPristine()) next();
    this.modalCancel = true;
    this.nextRoute = to;
  },
  data: () => ({
    toolbarSteps,
    currentStep: firstStep,
    steps: tabSteps,
    itemSteps: itemSteps,
    cancel: false,
    modalCancel: false,
    returnStep: false,
    isEditModality: false,
    positionSubModality: null,
    showForms: false,
    copyForm: null
  }),
  components: {
    InsuranceStepForm,
    InsuranceStepModality,
    ModalCancelInsurance,
    NewRelationshipContact,
    ListModality,
    EditModalityChosen,
    ListSubModality,
    EditSubModalityChosen
  },
  mixins: [LoadingRequest, InsuranceCompanyMixin],
  computed: {
    ...mapState("insuranceCompany", ["currentInsuranceCompany"]),
    ...mapState("quotation", ["listSubModality"]),
    formAccordingStep() {
      return this.itemSteps.find(x => x.step == this.currentStep.name).form;
    },
    breadcrumbAccordingStep() {
      const current = this.itemSteps.find(x => x.step == this.currentStep.name);
      return this.currentStep.name == "insurance_company new contact"
        ? current.form.id
          ? current.breadcrumbEdit
          : current.breadcrumbAdd
        : current.breadcrumb;
    },
    hasToolbarStep() {
      return (
        this.currentStep.name == this.steps.form ||
        this.currentStep.name == this.steps.modality
      );
    }
  },
  created() {
    this.fetchInsuranceCompany();
  },
  methods: {
    ...mapActions("insuranceCompany", [
      "requestEditInsuranceCompany",
      "requestCurrentInsuranceCompany",
      "requestUploadLogo"
    ]),
    ...mapActions(["showAlertNotification"]),
    fetchInsuranceCompany() {
      this.withLoading(
        this.requestCurrentInsuranceCompany(this.$route.params.id)
      );
    },
    formIsPristine() {
      // Obrigado mask por facilitar minha vida ...
      const normalizeDocument = value => normalizeCnpj(value);
      return (
        _.isEqual(this.itemSteps[1].form, this.copyForm[1].form) &&
        _.isEqual(
          _.omit(this.itemSteps[0].form, ["cnpj", "nome_fantasia", "endereco"]),
          _.omit(this.copyForm[0].form, ["cnpj", "nome_fantasia", "endereco"])
        ) &&
        normalizeDocument(this.itemSteps[0].form.cnpj) ===
          normalizeDocument(this.copyForm[0].form.cnpj) &&
        _.isEqual(
          _.omit(this.itemSteps[0].form.endereco, ["cep"]),
          _.omit(this.copyForm[0].form.endereco, ["cep"])
        ) &&
        this.itemSteps[0].form.endereco.cep.replace(/\D/g, "") ===
          this.copyForm[0].form.endereco.cep.replace(/\D/g, "")
      );
    },
    updateInsuranceCompany() {
      this.itemSteps[0].form.ativo = this.currentInsuranceCompany.ativo;
      this.itemSteps[0].form.nome = this.currentInsuranceCompany.nome;
      this.itemSteps[0].form.cnpj = this.currentInsuranceCompany.cnpj;
      this.itemSteps[0].form.razao_social = this.currentInsuranceCompany.razao_social;
      this.itemSteps[0].form.nome_fantasia = this.currentInsuranceCompany.nome_fantasia;
      this.itemSteps[0].form.registro_susep = this.currentInsuranceCompany.registro_susep;
      this.itemSteps[0].form.categoria = this.currentInsuranceCompany.categoria;
      this.itemSteps[0].form.endereco = this.currentInsuranceCompany.endereco;
      this.itemSteps[0].form.contatos_linha_credito = this.currentInsuranceCompany.contatos_linha_credito;
      this.itemSteps[0].form.contatos_relacionamento = this.currentInsuranceCompany.contatos_relacionamento;
      this.itemSteps[0].form.logo = this.currentInsuranceCompany.logo;
      this.itemSteps[1].form.aceita_link_arquivos = this.currentInsuranceCompany.aceita_link_arquivos;
      this.itemSteps[1].form.tamanho_maximo_arquivos_mb = this.currentInsuranceCompany.tamanho_maximo_arquivos_mb;
      this.itemSteps[1].form.modalidades = this.currentInsuranceCompany.modalidades;
      this.copyForm = _.cloneDeep(this.itemSteps);
      this.showForms = true;
    },
    stepRelationshipContact(payload) {
      this.returnStep = false;
      // Atualiza o formulário do passo atual
      this.itemSteps.find(x => x.step == this.currentStep.name).form =
        payload.form;
      // Atualiza o formulário do contatos de relacionamento
      // para saber se estou editando o contato
      // ou criando um novo contato
      this.itemSteps.find(x => x.step == this.steps.newContact).form =
        payload.item;
      this.currentStep = payload.step;
    },
    changeStep(payload) {
      this.returnStep = false;
      this.isEditModality = false;
      this.itemSteps.find(x => x.step == this.currentStep.name).form =
        payload.form;
      this.currentStep = payload.step;
    },
    saveModality(payload) {
      // Reseta o formulário de editar modalidade
      this.itemSteps.find(x => x.step == this.steps.editModality).form = {};
      // Buscar o formulário que tenha a lista
      // das modalidades
      let form = this.itemSteps.find(x => x.step == this.steps.modality).form
        .modalidades;
      let existingModalityForm = form.find(f => {
        return f.modalidade.id === payload.form.modalidade.id;
      });
      // verifica se ele já existe na lista ou não
      if (existingModalityForm) {
        const index = form.indexOf(existingModalityForm);
        form[index] = _.cloneDeep(payload.form);
      } else {
        form.push(payload.form);
      }
      this.returnStep = false;
      this.currentStep = payload.step;
    },
    closeModal(value) {
      this.cancel = value;
      this.modalCancel = false;
      if (value) {
        this.$router.push({ name: this.nextRoute.name });
      }
    },
    previousStep(to) {
      // Como o breadcrumb precisa ficar no pai por conta
      // de ser um template slot, preciso mandar para o filho
      // a informação que ele deseja voltar para o passo
      // anterior, para o filho poder enviar o formulário
      // para o pai, antes de mudar de componente
      if (to == "insurance_company") {
        this.$router.push({ name: to });
      } else {
        this.returnStep = true;
      }
    },
    getForm(step) {
      return this.itemSteps.find(x => x.step == step).form;
    },
    async submit(form) {
      // TODO: fazer integração
      this.itemSteps.find(x => x.step == this.steps.modality).form = form;
      // Se for um objeto e não for nulo e ter sido modificado,
      //  a imagem foi trocada então deve-se atualizar a foto
      if (
        typeof this.itemSteps[0].form.logo === "object" &&
        this.itemSteps[0].form.logo != null &&
        !this.itemSteps[0].form.logo.url
      )
        this.itemSteps[0].form.logo = await this.withLoading(
          this.requestUploadLogo(
            this.getUploadFilePayload(this.itemSteps[0].form.logo)
          )
        );
      await this.withLoading(
        this.requestEditInsuranceCompany(
          this.payloadEditInsuranceCompany()
        ).then(() => {
          this.cancel = true;
          this.showAlertNotification({
            message: `Seguradora editada com sucesso.`,
            type: "success"
          });
          this.$router.push({ name: "insurance_company" });
        })
      );
    },
    payloadEditInsuranceCompany() {
      return {
        payload: this.getPayload(this.itemSteps),
        id: this.$route.params.id
      };
    },
    newModality(payload) {
      this.itemSteps.find(x => x.step == this.steps.editModality).form = {
        ativo: true
      };
      this.changeStep(payload);
    },
    editModality(payload) {
      // Atualiza o form da lista de modalidades
      // para mostrar a modalidade escolhida
      // que será editada
      this.itemSteps.find(x => x.step == this.steps.selectModality).form =
        payload.item.modalidade;
      this.itemSteps.find(x => x.step == this.steps.editModality).form =
        payload.item;
      this.changeStep(payload);
      this.isEditModality = true;
    },
    getModality() {
      return this.isEditModality ? this.getForm(this.steps.selectModality) : {};
    },
    editSubModality(payload, position) {
      this.itemSteps.find(x => x.step == this.steps.selectSubModality).form =
        payload.item.submodalidade;
      this.itemSteps.find(x => x.step == this.steps.editSubModality).form =
        payload.item;
      this.positionSubModality = position;
      this.changeStep(payload);
    },
    newSubModality(payload) {
      this.changeStep(payload);
      this.itemSteps.find(
        x => x.step == this.steps.selectSubModality
      ).form = {};
      this.itemSteps.find(x => x.step == this.steps.editSubModality).form = {
        ativo: true
      };
      this.positionSubModality = null;
      this.changeStep(payload);
    },
    saveSubModality(payload) {
      // Reseta o formulário de editar sub modalidade
      this.itemSteps.find(x => x.step == this.steps.editSubModality).form = {};
      this.itemSteps.find(
        x => x.step == this.steps.selectSubModality
      ).form = {};
      // Buscar o formulário que tenha a lista
      // das modalidades
      let form = this.itemSteps.find(x => x.step == this.steps.editModality)
        .form.submodalidades;
      // verifica se ele já existe na lista ou não
      if (this.positionSubModality == null) {
        payload.form.submodalidade = this.listSubModality.find(
          e => e.nome === payload.form.submodalidade.nome
        );
        form.push(payload.form);
      } else {
        form[this.positionSubModality] = payload.form;
      }
      this.returnStep = false;
      this.currentStep = payload.step;
      this.positionSubModality = null;
    },
    setReturnFalse() {
      this.returnStep = false;
    }
  },
  watch: {
    currentInsuranceCompany() {
      this.updateInsuranceCompany();
    }
  }
};
</script>
